import * as React from "react"

export default function SvgVerticalAlignBottom(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M5 21a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 20q0-.424.287-.712A.97.97 0 0 1 5 19h14q.424 0 .712.288A.97.97 0 0 1 20 20q0 .424-.288.712A.97.97 0 0 1 19 21zm7-4.425a1.1 1.1 0 0 1-.375-.063.9.9 0 0 1-.325-.212l-3.625-3.625A.92.92 0 0 1 7.4 12q0-.4.3-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l1.9 1.9V4q0-.425.288-.713A.97.97 0 0 1 12 3a.97.97 0 0 1 .713.287A.97.97 0 0 1 13 4v9.2l1.925-1.925A.92.92 0 0 1 15.6 11q.4 0 .7.3a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-3.6 3.6q-.15.15-.325.212a1.1 1.1 0 0 1-.375.063" />
    </svg>
  )
}
